export const SOCIAL_PLATFORMS = [
  {
    key: 'whatsapp',
    label: 'WhatsApp',
    hosts: ['wa.me', 'whatsapp.com', 'api.whatsapp.com', 'web.whatsapp.com'],
  },
  { key: 'instagram', label: 'Instagram', hosts: ['instagram.com'] },
  { key: 'facebook', label: 'Facebook', hosts: ['facebook.com', 'fb.com'] },
  { key: 'threads', label: 'Threads', hosts: ['threads.net'] },
];

function parseLinks(value) {
  if (!value) return {};
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
      return {};
    }
  }
  return typeof value === 'object' ? value : {};
}

function nestedUrl(links, key) {
  const entry = links?.[key];
  if (typeof entry === 'string') return entry;
  if (entry && typeof entry.url === 'string') return entry.url;
  return '';
}

export function readSocialMap(profile, card) {
  const links = {
    ...parseLinks(card?.social_links),
    ...parseLinks(profile?.social_links),
  };
  const map = {};
  for (const platform of SOCIAL_PLATFORMS) {
    map[platform.key] = String(
      nestedUrl(links, platform.key) || card?.[`${platform.key}_link`] || '',
    ).trim();
  }
  return map;
}

/** missing | invalid | valid. Only http(s) on the platform host counts as valid. */
export function classifySocialUrl(platformKey, raw) {
  const value = String(raw || '').trim();
  if (!value) return { status: 'missing', href: '' };
  let url;
  try {
    url = new URL(value);
  } catch {
    return { status: 'invalid', href: '' };
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') {
    return { status: 'invalid', href: '' };
  }
  const host = url.hostname.replace(/^www\./, '').toLowerCase();
  const platform = SOCIAL_PLATFORMS.find((item) => item.key === platformKey);
  const allowed = platform?.hosts.some(
    (item) => host === item || host.endsWith(`.${item}`),
  );
  if (!allowed) return { status: 'invalid', href: '' };
  return { status: 'valid', href: url.href };
}
